import { ShareIcon } from '@heroicons/react/24/outline';
import {
  formatBundleExplosionUnits,
  getBundleExplosionStatusLabel,
} from '../../../lib/bundleDemandExplosionHelpers';

function statusTone(hasException) {
  return hasException
    ? 'border-transparent bg-amber-50 text-amber-700'
    : 'border-transparent bg-emerald-50 text-emerald-700';
}

export function BundleDemandExplosionMainTable({ rows, onInspectRow }) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="max-h-[calc(100vh-10rem)] overflow-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="sticky top-0 z-10 bg-slate-50 text-xs uppercase tracking-[0.12em] text-gray-500">
            <tr>
              <th className="px-4 py-3 font-medium">Execution SKU</th>
              <th className="px-4 py-3 font-medium">Execution product</th>
              <th className="px-4 py-3 font-medium">Component SKU</th>
              <th className="px-4 py-3 font-medium">Component product</th>
              <th className="px-4 py-3 font-medium">Supplier</th>
              <th className="px-4 py-3 text-right font-medium">Units / bundle</th>
              <th className="px-4 py-3 text-right font-medium">Forecast units</th>
              <th className="px-4 py-3 text-right font-medium">Component units</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 text-right font-medium">Drill-through</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map(row => (
                <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="px-4 py-3 align-top font-medium text-gray-900">{row.executionSku}</td>
                  <td className="px-4 py-3 align-top text-gray-600">{row.executionProductName}</td>
                  <td className="px-4 py-3 align-top font-medium text-gray-900">{row.componentSku}</td>
                  <td className="px-4 py-3 align-top text-gray-600">{row.componentProductName}</td>
                  <td className="px-4 py-3 align-top text-gray-600">{row.supplier}</td>
                  <td className="px-4 py-3 text-right align-top text-gray-900">
                    {formatBundleExplosionUnits(row.unitsPerBundle)}
                  </td>
                  <td className="px-4 py-3 text-right align-top text-gray-900">
                    {formatBundleExplosionUnits(row.forecastUnits)}
                  </td>
                  <td className="px-4 py-3 text-right align-top font-medium text-gray-900">
                    {formatBundleExplosionUnits(row.componentUnits)}
                  </td>
                  <td className="px-4 py-3 align-top">
                    <span
                      className={`inline-flex rounded-md border px-2 py-1 text-[11px] whitespace-nowrap font-medium ${statusTone(row.hasException)}`}
                    >
                      {getBundleExplosionStatusLabel(row)}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right align-top">
                    <button
                      type="button"
                      className="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50"
                      onClick={() => onInspectRow?.(row.id)}
                    >
                      <ShareIcon className="h-3.5 w-3.5" aria-hidden />
                      Inspect
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="px-4 py-10 text-center text-sm text-gray-500" colSpan={10}>
                  No bundle demand rows match the current search or exception filter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
